/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-card-head{background-color:#219bd7;padding:5px 24px;display:flex;flex-shrink:0;justify-content:flex-start;align-items:center}.modal-card-title{color:#eee;flex-grow:1;flex-shrink:0;font-size:16px}"];
export { styles as styles };
